import { Hero } from "../sections/Hero";
import { Marquee } from "../components/Marquee";
import { ChristmasBanner } from "../sections/ChristmasBanner";
import { ShopGrid } from "../sections/ShopGrid";
import { Lookbook } from "../sections/Lookbook";
import { Manifesto } from "../sections/Manifesto";

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <ChristmasBanner />
      <ShopGrid />
      <Lookbook />
      <Manifesto />
    </>
  );
}
